import { useEffect, useState } from "react";
import axios from "axios";
import { API_URL, BACKEND_URL } from "../lib/utils";

let cache = null;
let pending = null;

// Marca da empresa associada ao domínio em que a app está aberta (marca branca). Um pedido por sessão de página.
export const fetchBranding = () => {
  if (cache) return Promise.resolve(cache);
  if (!pending) {
    pending = axios
      .get(`${API_URL}/public/branding`)
      .then((r) => { cache = r.data || { branded: false }; return cache; })
      .catch(() => { cache = { branded: false }; return cache; });
  }
  return pending;
};

export const resolveLogo = (logo) => (logo && logo.startsWith("/api") ? `${BACKEND_URL}${logo}` : logo || "");

export const useBranding = () => {
  const [branding, setBranding] = useState(cache);
  useEffect(() => {
    let alive = true;
    fetchBranding().then((b) => { if (alive) setBranding(b); });
    return () => { alive = false; };
  }, []);
  return { branding: branding || { branded: false }, loaded: branding !== null };
};
